module.exports = {"pathContext":{"name":"CareCreditEntityType","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"CLIENT"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"ESTIMATE"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"ORDER"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-care-credit-entity-type.json
// module id = 1215
// module chunks = 204254412281710